import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { map, catchError, mergeMap } from 'rxjs/operators';
import { Observable, from, throwError, Subject, BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { AlertController, NavController, ToastController } from '@ionic/angular';
import { NavigationExtras } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  private baseurl = environment.Baseurl;
  public iid = environment.institute_id;
  private branch_id = environment.branch_id;

  private header = new Headers({ 'Content-Type': 'application/json', 'User-Agent': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_1) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/62.0.3202.94 Safari/537.36' });
  private options = new RequestOptions({ headers: this.header });

  public institute_id = new Subject();
  public institute_id$ = this.institute_id.asObservable();

  public screenType:any = 'web';

  public ismobile = new Subject<any>();
  public ismobile$ = this.ismobile.asObservable();

  public permission = new Subject<any>();
  public permission$ = this.permission.asObservable();

  public instituteLogo = new Subject<any>();
  public instituteLogo$ = this.instituteLogo.asObservable();

  public appversion = new Subject<any>();
  public appversion$ = this.appversion.asObservable();

  public course_id = new Subject<any>();
  public course_id$ = this.course_id.asObservable();

  public loginType = new Subject<any>();
  public loginType$ = this.loginType.asObservable();

  constructor(
    private http: HttpClient,
    private toast: ToastController,
    public alertController: AlertController,
    public navCtrl: NavController
  ) {
  }

  errorHandler(errors: HttpErrorResponse) {
    if (errors.error instanceof ErrorEvent) {
      console.error('An error occurred:', errors.error.message);
    } else {
      console.error(
        `Backend returned code ${errors.status}, ` +
        `body was: ${errors.error}`);
    }
    return throwError(
      'Something bad happened; please try again later.');
  }

  removeDuplicates(originalArray, prop) {
    var obj = {};

    for ( var i=0, len=originalArray.length; i < len; i++ )
        obj[originalArray[i][prop]] = originalArray[i];

        originalArray = new Array();
    for ( var key in obj )
      originalArray.push(obj[key]);

    console.log(originalArray)

    return originalArray;
  }

  async showToast(displayMessage: string, position?: 'bottom' | 'top' | 'middle', duration?: number) {
    const toast = await this.toast.create({
      message: displayMessage,
      duration: duration || 3000,
      position: position || 'bottom'
    });
    toast.present();
  }

  getAllStates(){
    const url = 'http://www.geonames.org/childrenJSON?geonameId=1269750&callback=listPlaces&style=long&noCacheIE=1625880722198'
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
    }), catchError(this.errorHandler));
  }

  getNonSecureAboutInstitute() {
    const url = this.baseurl + '/AboutInstitute?institute_id=' + this.iid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getNonSecureInstituteCourses(branch_id){
    const url = this.baseurl + '/CourseInstitute?institute_id=' + this.iid + '&is_show_for_app=true'+'&branch_id=' + branch_id;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getNonSecureInstituteEvents(){
    const url = this.baseurl + '/EventInstitute?institute_id=' + this.iid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getInstituteSocialShare(){
    const url = this.baseurl + '/InstituteSocialShare?institute_id=' + this.iid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));

  }
  getInstituteSlider(){
    const url = this.baseurl + '/InstituteMobileSlider?institute_id=' + this.iid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));

  }

  getBanner() {
    const url = this.baseurl + '/OnlineSeo?type=institute&id=' + this.iid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getBlogs() {
    const url = this.baseurl + '/Blog?type=category&institute_id=' + this.iid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getBlogDetail(blogid) {
    const url = this.baseurl + '/Blog?id=' + blogid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getTestimonialImgVideo(mediaType, categoryId) {
    const url = this.baseurl + '/media?institute_id=' + this.iid + '&media_type=' + mediaType + '&category_id=' + categoryId;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getNonSecureAllFaculty() {
    const url = this.baseurl + '/Faculty?type=all_faculty&institute_id=' + this.iid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getFaculty(bid) {
    const url = this.baseurl + '/Faculty?institute_id=' + this.iid + '&branch_id=' + bid;;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getFacultyInfo(id) {
    const url = this.baseurl + '/Faculty?id=' + id;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getGallery(){
    const url = this.baseurl + '/Gallery?institute_id=' + this.iid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getGalleryFaculty(){
    const url = this.baseurl + '/Gallery?institute_id=' + this.iid + "&branch_id=" + this.branch_id;;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getGalleryImages() {
    const url = this.baseurl + '/ServiceMedia?institute_id=' + environment.institute_id;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
    }));
  }

  getBranch() {
    const url = this.baseurl + '/Branch?type=branch&institute_id=' + this.iid + '&view_on_app=true';
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getBranchCourse(branch_id) {
    const url = this.baseurl + '/Course?institute_id=' + this.iid + '&branch_id=' + branch_id;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  GetSlots(course_id, day ) {
    const url = this.baseurl + '/GetSlots?course_id=' + course_id + '&day=' + day;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getSubject(bid, cid) {

    let admission_id;

    if(localStorage.getItem('currentUser')){
      admission_id = JSON.parse(localStorage.getItem('currentUser')).admission_id;
    }
    else{
      admission_id = '';
    }

    const url = this.baseurl + '/Subject?institute_id=' + this.iid + '&branch_id=' + bid + '&course_id=' + cid + '&admission_id=' + admission_id;
    //const url = 'https://edusome.azurewebsites.net/api/Subject?institute_id=57&branch_id=298&course_id=1783&admission_id=';
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getAllSubjects(bid, cid, uid) {

    const url = this.baseurl + '/Subject?institute_id=' + this.iid + '&branch_id=' + bid + '&course_id=' + cid+ '&student_id=' + uid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }
  
  getTest(sid, uid) {
    const url = this.baseurl + '/StudentTestPaper?institute_id=' + this.iid + '&subject_id=' + sid + '&student_id=' + uid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getTestByCourse(cid, sid) {
    const url = this.baseurl + '/StudentTestPaper?institute_id=' + this.iid + '&branch_id='+ this.branch_id + '&course_id='+cid+'&subject_id='+sid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }



  getAllTest(branch_id) {
    const url = this.baseurl + '/TestPaper?institute_id=' + this.iid + '&branch_id=' + branch_id;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getAnnouncement() {
    const url = this.baseurl + '/Announcement?institute_id=' + this.iid + '&announcement_category_id =' + null + '&skip =' + null + '&take=' + null;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  setAnnouncement(data) {
    const url = this.baseurl + '/Announcement';
    return this.http.post(url, data)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }
  
  getPersonalizedTests(sid, uid) {
    const url = this.baseurl + '/PersonalTest?institute_id=' + this.iid + '&subject_id=' + sid + '&student_id=' + uid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  TestResult(bid, uid) {
    const url = this.baseurl + '/StudentTestSubmissions?institute_id=' + this.iid + '' + '&branch_id=' + bid + '&student_id=' + uid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  StudentTestSubmissions(tid, uid) {
    const url = this.baseurl + '/StudentTestSubmissions?institute_id=' + this.iid + '' + '&branch_id=' + this.branch_id + '&student_id=' + uid +'&test_id='+tid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getTimetable(cid, bid) {

    const url = this.baseurl + '/ClassTimeTable?course_id=' + cid + '&section=' + bid + '&subject_id=&faculty_id=';

    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getAttendenceBatch(uid) {
    const url = this.baseurl + '/StudentAttendance?student_id=' + uid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getFeesManagement(type) {
    const url = this.baseurl + '/FeesManagement?type=' + type + '&institute_id=' + this.iid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getFranchiseCommissionPayment(type) {
    const url = this.baseurl + '/FranchiseCommissionPayment?type=' + type + '&institute_id=' + this.iid + '&branch_id=298';
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }


  getAttendence(uid, batchId, bid) {
    const url = this.baseurl + '/StudentAttendance?student_id=' + uid +
    '&batch_id=' + batchId + '&institute_id=' + this.iid + '&branch_id=' + bid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getAllAttendence(batch_id) {
    const url = this.baseurl + '/Attendance?batch_id=' + batch_id;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  setAttendence(student_id, batch_id, faculty_id) {
    const url = this.baseurl + '/Attendance/PostAttendance?student_id=' + student_id + '&batch_id=' + batch_id + '&faculty_id=' + faculty_id;
    return this.http.post(url, {})
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  RequestDemoClass(data) {
    const url = this.baseurl + '/RequestDemoClass';
    return this.http.post(url, data)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  Request(data) {
    const url = this.baseurl + '/Request';
    return this.http.post(url, data)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getAchivers(bid) {
    const url = this.baseurl + '/Achiever?institute_id=' + this.iid + '&branch_id=' + bid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getEvents(bid) {
    const url = this.baseurl + '/Event?institute_id=' + this.iid + '&branch_id=' + bid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getStudyMaterialBySubject(uid, sid, typeId) {
    const url = this.baseurl + '/Study?institute_id=' + this.iid + '&student_id=' + uid + '&subject_id=' + sid + '&study_type=' + typeId;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getStudyMaterialForFaculty(faculty_id) {
    const url = this.baseurl + '/StudyMaterial?institute_id=' + this.iid + "&faculty_id=" + faculty_id;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }
  
  getMockTestBySubject(uid, sid, course_id) {
    const url = this.baseurl + '/MockTest?institute_id=' + this.iid + '&student_id=' + uid + '&subject_id=' + sid + '&course_id=' + course_id;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getMockTestDetail(testId) {
    const url = this.baseurl + '/MockTest/' + testId;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }


  setNewUser(userInfo) {
    console.log(userInfo);
    const url = this.baseurl + '/Student';
    return this.http.post(url, userInfo)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getAdmission(admission_id) {
    const url = this.baseurl + '/admission?id=' + admission_id;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  newAdmission(userAdnissionInfo) {
    console.log(userAdnissionInfo);
    const url = this.baseurl + '/admission';
    return this.http.post(url, userAdnissionInfo)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  updateAdmission(data){
    console.log(data)
    const url = this.baseurl + '/admission/';
    return this.http.put(url, data)
    .pipe(map((resp: any) => {
        return resp;
    }), catchError(this.errorHandler));
  }

  getStudentCourses(uid) {
    const url = this.baseurl + '/StudentCourses?student_id=' + uid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  postQuery(value) {
    const url = this.baseurl + '/Enquiry';
    return this.http.post(url, value)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  postQueryV2(value) {
    const url = this.baseurl + '/Enquiry/EnquiryV2';
    return this.http.post(url, value)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getEnquiryCategory() {
    const url = this.baseurl + '/EnquiryCategory?type=enquirycategory' + '&institute_id='+ this.iid;

    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getPaymentHistory(aid, type) {
    const url = this.baseurl + '/StudentPaymentHistory/' + aid + '?type=' + type;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  StudentPaymentHistory(value) {
    const url = this.baseurl + '/StudentPaymentHistory';
    return this.http.post(url, value)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getDateSheet(bid){
    const url = this.baseurl + '/DateSheet?institute_id=' + this.iid + '&branch_id=' + bid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getDateSheetDetails(eid){
    const url = this.baseurl + '/DateSheet/' + eid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getOnlineClassList(uid){
    const url = this.baseurl + '/LiveStreaming?student_id=' + uid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));

  }

  instituteEnquiry(value) {
    const url = this.baseurl + '/Enquiry';
    return this.http.post(url, value)
    .pipe(map((resp: any) => {
      return resp;
    }), catchError(this.errorHandler));
  }






  getAllParticipant(bid) {
    const institute_id = JSON.parse(localStorage.getItem('instituteId'));
    const url = this.baseurl + '/Student?type=student_message&institute_id=' + institute_id + '&branch_id=' + bid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }
  getChatParticipant(bid, uid) {
    const institute_id = JSON.parse(localStorage.getItem('instituteId'));
    const url = this.baseurl + '/Message?institute_id=' + institute_id + '&branch_id=' + bid + '&user_id=' + uid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }
  getUserMessages(reciverId, uid) {
    const institute_id = JSON.parse(localStorage.getItem('instituteId'));
    const url = this.baseurl + '/Message?id=' + reciverId + '&user_id=' + uid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  sendMessages(data) {
    const institute_id = JSON.parse(localStorage.getItem('instituteId'));
    const url = this.baseurl + '/Message';
    return this.http.post(url, data)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getOffers(bid) {
    const url = this.baseurl + '/ReferralSchemes?institute_id=' + this.iid + '&branch_id=' + bid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getStudentCiscoWebinar(uid){
    const url = this.baseurl + '/StudentCiscoWebinar?student_id=' + uid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));

  }

  getDeepInsights(test_id, student_id) {
    const url = this.baseurl + '/HotspotAnalysis?test_id=' + test_id + '&student_id=' + student_id;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getResultOverview(test_id, student_id) {
    const url = this.baseurl + '/OnlineTest?type=submitted_test&id=' + test_id + '&student_id=' + student_id;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getTestResult(test_id, student_id) {
    const url = this.baseurl + '/TestResult?test_id=' + test_id + '&student_id=' + student_id + '&no_of_results=0';
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getStudentTestPaper(test_id) {
    const url = this.baseurl + '/StudentTestPaper/' + test_id;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  submitOnlineTestPaper(data) {
    const url = this.baseurl + '/StudentTestPaper/';
    return this.http.post(url, data)
    .pipe(map((resp: any) => {
        return resp;
    }), catchError(this.errorHandler));
  }

  submitTestPaper(test_id, student_id) {
    const url = this.baseurl + '/StudentTestPaper?test_id=' + test_id + '&student_id=' + student_id;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }
  SpeedTestTrigger(test_id, student_id, type) {
    const url = this.baseurl + '/SpeedTestTrigger?test_id=' + test_id + '&student_id=' + student_id + '&type=' + type;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  } 

  HotspotFeedback(test_id, student_id, comment_text, rating_value, data) {
    const url = this.baseurl + '/HotspotFeedback?fk_student_id=' + student_id + '&fk_test_paper_id=' + test_id + '&comment_text=' + comment_text +'&rating_value=' + rating_value;
    return this.http.post(url, data)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getPersonalTest(test_id, student_id, type) {
    const url = this.baseurl + '/PersonalTest?test_id=' + test_id + '&student_id=' + student_id + '&type=' + type;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  PersonalTestDetailsResults(test_id, student_id, test_type) {
    const url = this.baseurl + '/PersonalTestResultDetails?parent_test_id=' + test_id + '&student_id=' + student_id + '&test_type=' + test_type;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  async errorAlert(loading){
    loading.dismiss();
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Sorry!',
      subHeader: 'Something went wrong!',
      message: 'We are unable to process your request now. Please try again later.',
      buttons: [
        {
          text: 'Okay',
          role: 'cancel',
          cssClass: 'secondary',
          handler: async (blah) => {
            await alert.dismiss();
            loading.dismiss();
          }
        }
      ],
      backdropDismiss: false
    });

    await alert.present();
  }


  getInstitution() {
    const url = this.baseurl + '/Institution?edusome_base_ecom=true';
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }
    

  getinfo() {
    const url = this.baseurl + '/info/';
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }



  tempCourses() {
    const url = 'https://edusome-dev.azurewebsites.net/api/StudentCourses?student_id=1085';
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }
    

  getAllOnlineClasses(value) {
    const url = this.baseurl + '/v1/online-classes/get-all-online-class';
    return this.http.post(url, value)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }


  getBranches() {
    const url = this.baseurl + '/ChangeInstituteBranch?type=branch&institute_id=' + this.iid+'&view_on_app=true';
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getBranchesForEnquiry() {
    const url = this.baseurl + '/ChangeInstituteBranch?type=branch&institute_id=' + this.iid+'&view_on_app=true&view_on_enquiry=true';
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }
    

  /* ***************ECOMMERCE APIS******************** */

  getStudyMaterials(uid, study_type) {
    const url = this.baseurl + '/Study?institute_id=' + this.iid + '&student_id=' + uid +'&subject_id=null&study_type='+ study_type;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getMedia() {
    const url = this.baseurl + '/Media?institute_id=' + this.iid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getMediaAll(mediaType, isPrivate) {
    const url = this.baseurl + '/media?institute_id=' + this.iid + '&media_type=' + mediaType + '&is_private=' + isPrivate;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getServiceMedia() {
    const url = this.baseurl + '/ServiceMedia?institute_id=' + this.iid + '&branch_id=' + this.branch_id;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getCourses(branch_id) {
    const url = this.baseurl + '/DropDown?type=course_type' + '&institute_id='+ this.iid + '&branch_id=' + branch_id+'&is_show_for_app=true';
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }
  
    

  getBanners() {
    const url = this.baseurl + '/media?institute_id=' + this.iid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getSubjects(course_id) {
    const url = this.baseurl + '/DropDown?type=subject_type' + '&institute_id='+ this.iid + '&branch_id=' + this.branch_id + '&id=' + course_id;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getBatches(suject_id) {
    const url = this.baseurl + '/DropDown?type=batch' + '&institute_id='+ this.iid + '&id=' + suject_id;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  } 

  BatchStudents(bid) {
    const url = this.baseurl + '/BatchStudents?fk_batch_id='+ bid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  } 


  getAllBatches(course_id, sid) {
    const url = this.baseurl + '/Batch?institute_id='+ this.iid + '&branch_id=' + this.branch_id + '&course_id=' + course_id + '&subject_id=' + sid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

    
 getSubjectDetails(id) {
    const url = this.baseurl + '/Subject?id=' + id;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getCategories() {
    const url = this.baseurl + '/DropDown?type=course_asset_type';
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getProducts(institute_id, branch_id, course_id, subject_id, category_id) {
    const url = this.baseurl + '/Assets?institute_id='+ institute_id + '&branch_id=' + branch_id + '&course_id=' + course_id + '&subject_id=' + subject_id + '&category_id=' + category_id;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getProductDescription(asset_id) {
    const url = this.baseurl + '/Assets?id=' + asset_id;  
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }


  getSubjectIcon(subject_name){
    
    if(subject_name.includes('struture')){
      return 'datastructure.jpg'
    }
    else if(subject_name.includes('dbms')){
      return 'dbms.jpg'
    }
    else if(subject_name.includes('maths')){
      return 'math.jpg'
    }
    else if(subject_name.includes('english')){
      return 'english.jpg'
    }
    else if(subject_name.includes('c++')){
      return 'cplusplus.jpg'
    }
    else if(subject_name.includes('science')){
      return 'science.jpg'
    }
    else if(subject_name.includes('biology')){
      return 'biology.jpg'
    }
    else{
      return 'default.jpg'
    }


  }
  
  openEstore(){
        if(environment.AppName == 'edusome'){
          this.navCtrl.navigateForward('/institutes-list');
        }
        else{
          const navigationExtras: NavigationExtras = {
            state: {
              dataset: {
                'institute_id': this.iid
              }
            }
          };
          this.navCtrl.navigateForward(['/products-list'] , navigationExtras);
        }
    
  }
      


  GetInstitutePermissions() {
    const url = this.baseurl + '/Institution/GetInstitutePermissions?id=' + this.iid;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  async notAvailable(header:any){
      const alert = await this.alertController.create({
        cssClass: 'custom-alert-class',
        header: header,
        subHeader: 'Oops!!!',
        message: 'This feature is not available for your institute. Please contact to the administrator for more information.',
        buttons: ['Okay']
      });
      await alert.present();
      return false;
  }



  getPaymentTransaction(trackingId) {
    const url = this.baseurl + '/PaymentTransaction?tracking_id=' + trackingId ;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }
  
  serviceBooking(data) {
    const url = this.baseurl + '/Admission';
    return this.http.post(url, data)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  productBooking(data) {
    const url = this.baseurl + '/Admission';
    return this.http.post(url, data)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getMyOrders() {
    const url = this.baseurl + '/Order?type=order_grid&institute_id='+ this.iid;
    return this.http.get(url)
    .pipe(map((resp: any) => {
      return resp;
    }), catchError(this.errorHandler));
  }
  

  MasterAttendanceStatus() {
    const url = this.baseurl + '/MasterAttendanceStatus';
    return this.http.get(url)
    .pipe(map((resp: any) => {
      return resp;
    }), catchError(this.errorHandler));
  }

  GetOrders(student_id) {
    const url = this.baseurl + '/Order/GetOrderDetailsById?student_id=' + student_id;
    return this.http.post(url, {})
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }



  /* ****************FILTER SECTION*************** */

  getBranchesFilter() {
    const url = this.baseurl + '/Filter?type=branch_type&institute_id=' + this.iid+'&view_on_app=true';
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getCategoriesFilter(branch_id) {
    const url = this.baseurl + '/Filter?type=course_asset_type' + '&institute_id='+ this.iid + '&branch_id=' + branch_id;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getCoursesFilter(branch_id, uid) {
    const url = this.baseurl + '/Filter?type=course_type' + '&institute_id='+ this.iid + '&branch_id=' + branch_id+ '&student_id=' + uid+'&is_show_for_app=true';
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getSubjectsFilter(branch_id, course_id) {
    const url = this.baseurl + '/Filter?type=subject_type' + '&institute_id='+ this.iid + '&branch_id=' + branch_id + '&id=' + course_id;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  searchData(searchTerm, items, key) {
    return items.filter((item) => {
      return item.text.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    });
  }

  getMediaSubCategory() {
    const url = this.baseurl + '/MediaSubCategory?institute_id='+ this.iid + '&branch_id=' + this.branch_id + '&category_id=0';
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  getAdmissionList(year, month) {
    const url = this.baseurl + '/Admission?institute_id='+ this.iid + '&branch_id=' + this.branch_id + '&year=' + year + '&month=' + month
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  postDatesheetUrl(data) {
    const url = this.baseurl + '/DateSheet';
    return this.http.post(url, data)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  postStudyUrl(data) {
    const url = this.baseurl + '/StudyMaterial';
    return this.http.post(url, data)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  postUrl(data) {
    const url = this.baseurl + '/Gallery';
    return this.http.post(url, data)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  postAttendence(data) {
    const url = this.baseurl + '/Attendance';
    return this.http.post(url, data)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }


  getPersonalTestResult(parent_test_id, test_type) {
    const url = this.baseurl + '/PersonalTestResult?parent_test_id=' + parent_test_id + '&test_type=' + test_type;
    return this.http.get(url)
      .pipe(map((resp: any) => {
        return resp;
      }), catchError(this.errorHandler));
  }

  filterTestList(searchTerm,items) {
    return items.filter((item) => {
      if(item.title){
        return item.title.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
      }
      if(item.student_name){
        return item.student_name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
      }
    });
  }

  filterStudents(searchTerm,items){

    return items.filter((item) => {
        return item.student_name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    });

}




}
